<template>
  <b-row>
    <b-col>
      <b-card class="p-1 p-md-3">
        <b-card-title>
          {{ $t('deposit-text') }}
        </b-card-title>
        <b-row v-if="ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT">
          <b-col sm="12">
            <dashboard-alert
              variant="success"
              :title="$t('deposit-alert-text')"
            />
          </b-col>
        </b-row>
        <br>
        <b-row>
          <div class="d-flex flex-column flex-md-row  w-100 justify-content-center align-items-center">
            <DepositButton
              v-if="ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT"
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit/online`"
              :title-key="$t('bank_deposit')"
              :subtitle-key="$t('online-payment')"
            />
            <DepositButton
              v-if="ENABLED_CRYPTO_MEMO_BANK_DEPOSIT"
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit/memo`"
              :title-key="$t('bank_deposit')"
              :subtitle-key="$t('memo_bank_deposit')"
            />
            <DepositButton
              v-if="ENABLED_CRYPTO_WIRE_BANK_DEPOSIT"
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/deposit`"
              :title-key="$t('fiat_Deposit')"
              :subtitle-key="$t('bank-receipt')"
            />
            <DepositButton
              v-if="ENABLED_CRYPTO_WIRE_BANK_DEPOSIT"
              variant="primary"
              :to="`/${$i18n.locale}/crypto-wallets`"
              :title-key="$t('crypto Deposit')"
            />
          </div>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import Deposit from '@/modules/crypto/views/logic/customer-wallets/fiat/Deposit'
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import DepositButton from '../../components/DepositButton.vue'

export default {
  components: {
    DashboardAlert,
    DepositButton,
  },
  mixins: [Deposit],
}
</script>
<style>
.btn-style {
  margin: 5px;
  width: 100%;
  height: 100px;
}
</style>
